import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  CopyToClipboard,
  DetailCard,
  DropdownMenu,
  DualIcon,
  FormFieldSet,
  InfoTextAdv,
  LogoLoader,
  Modal,
  showToast,
  Skeleton,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { Link } from "react-router-dom";
import AddApplicantModal from "./AllApplicants/Modals/AddApplicantModal";

import { useDispatch, useSelector } from "react-redux";
import {
  clearApplicants,
  fetchAllApplicantsStart,
  updateApplicantNotes,
  updateApplicantsNotesArray,
  updateApplicantWithNotes,
} from "../../../../redux/slices/recruitmentSourcing/SourcingSlice";
import {
  addNoteApi,
  addClipboardLogApi,
  fetchClipboardLogsApi,
  addVisitHistoryApi,
  fetchVisitHistorysApi,
  fetchAllNotes,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import SubmitModal from "./Modal/SubmitModal";
import BulkModal from "./Modal/BulkModal";
import {
  fetchNoteApi,
  updateApplicantStatusApi,
} from "../../../../redux/slices/recruitmentSourcing/SourcingApi";
import ApplicantsDetailsDrawer from "./Modal/ApplicantsDetailsDrawer";
import { resumeParser } from "../../../../redux/slices/recruitmentSourcing/SourcingApi";
import {
  setAllApplicantAccessidStart,
  updateAllSourceNotes,
} from "../../../../redux/slices/internalDbES/internalDbESlice";
import { formatPhoneNumberLength, formatWords2 } from "../../../../utils/stringUtils";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { trackEvent } from "../../../../utils/mixpanelService";

const AllApplicants = () => {
  const sourceOptions = {
    1: "Internal",
    2: "Career builder",
    3: "Monster",
    4: "Career portal",
    5: "Careerjet",
    6: "Dice",
    7: "Glassdoor",
    8: "Indeed",
    9: "Linkedin",
    10: "Naukari",
    11: "Neuvoo",
    12: "Post job free",
    13: "Snaprecruit",
    14: "Stack overflow",
    15: "Ziprecruiter",
    16: "Employee referral",
    17: "Employment agency",
    18: "Gmail",
    19: "Job fair",
    20: "Others",
    21: "Outlook",
    22: "Passive sourcing",
    23: "Resume inbox",
  };
  const applicantStatus = {
    1: "Active",
    2: "Do not contact",
    3: "Blocked",
    4: "Do Not Call (Allowed to submit)",
    5: "Do Not Submit (Not allowed to submit)",
    6: "Out of market (Allowed to submit)",
    7: "Placed (Allowed to submit)"
  };
  const applicantStatusOptions = Object.entries(applicantStatus).map(([value, label]) => ({
    label,
    value: Number(value),
  }));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSingleNotes, setShowSingleNotes] = useState(false);
  const [note, setNote] = useState("");
  const [isAddManualModalOpen, setIsAddManualModalOpen] = useState(false);
  const [composeModal, setComposeModal] = useState(false);
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [notes, setNotes] = useState([]);
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [hoveredClipboardLogs, setHoveredClipboardLogs] = useState([]);
  const [hoveredVisitHistorys, setHoveredVisitHistorys] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [showDataId, setShowDataId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [submitModal, setSubmitModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [parsedResumeData, setParsedResumeData] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isParsing, setIsParsing] = useState(false);
  const [accessId, setAccessId] = useState(null);
  const [filteredApplicants, setFilteredApplicants] = useState(null);
  const [activeFilters, setActiveFilters] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchApplicants, setSearchApplicants] = useState([]);
  const [isBlockedModalOpen, setIsBlockedModalOpen] = useState(false);
  const [blockedComment, setBlockedComment] = useState("");
  const [selectedStatusOption, setSelectedStatusOption] = useState(null);
  const [selectedRowForStatus, setSelectedRowForStatus] = useState(null);

  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.allApplicants?.data || 0
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );
  // const totalCount = value?.allApplicants?.data || 0;
  const applicants = useSelector((state) => state.sourcing.applicants);

  const pageLoading = useSelector((state) => state.sourcing.loading);

  const { user } = useSelector((state) => state.auth);
  const { accessData } = useSelector((state) => state.internalDbES);
  const selectedApplicantwithNotes = applicants?.data.find(applicant => applicant?.uiid == selectedApplicant?.uiid)?.notesList || [];
  //console.log("selectedApplicantwithNotes", selectedApplicantwithNotes)
  const whatsappIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="WhatsApp"
    >
      <title>WhatsApp</title>

      <path
        fill="#25D366"
        d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
      />

      <path
        fill="#FFFFFF"
        d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
      />
    </svg>
  );

  const fileInputRef = useRef(null);

  const handleAddFilesClick = () => {
    if (!accessId && !accessData?.allapplicant?.[0]?.uiid) {
      showToast("AccessID not found!", "error");
      return;
    }
    fileInputRef.current.click();
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  const handleFileChange = async (e) => {
    if (isParsing) return;
    if (!accessId && !accessData?.allapplicant?.[0]?.uiid) {
      showToast("AccessID not found!", "error");
      return;
    }
    if (!e.target.files || e.target.files.length === 0) {
      e.target.value = null;
      return;
    }

    const filesArray = Array.from(e.target.files);
    if (uploadedFiles.length + filesArray.length > 1) {
      showToast("Maximum 1 file is allowed", "error");
      e.target.value = null;
      return;
    }

    const file = filesArray[0];
    const maxFileSize = 5 * 1024 * 1024;
    if (file.size > maxFileSize) {
      alert(`File "${file.name}" exceeds 5MB limit`, "error");
      e.target.value = null;
      return;
    }

    try {
      setLoading(true);
      setIsParsing(true);
      const formData = new FormData();
      formData.append("doc", file);
      formData.append("coll", "Candidate");
      formData.append(
        "accessId",
        accessId || accessData?.allapplicant?.[0]?.uiid
      );
      // const parsed = SAMPLE_RESPONSE.data;
      const res = await resumeParser(formData);
      const parsed = res?.data?.data || {};
      setParsedResumeData(parsed);
      setUploadedFile(file);
      setIsModalOpen(false);
      setIsAddManualModalOpen(true);
    } catch (error) {
      console.error(error);
      showToast("Failed to parse resume", "error");
    } finally {
      setLoading(false);
      setIsParsing(false);
      e.target.value = null;
    }
  };

  const handleClipboardLog = async (row, copyType) => {
    try {
      console.log("Logging clipboard copy for row:", row, "copyType:", copyType);
      if (!row?.uiid) return;
      await addClipboardLogApi({
        coll: "ClipBoardLog",
        payload: {
          candidateId: row.uiid,
          addedBy: user?.data?.uiid,
          copyType: copyType,
        },
      });
    } catch (error) {
      console.error("Error logging clipboard copy:", error);
    }
  };

  const handleVisitHistory = async (row) => {
    try {
      if (!row?.uiid) return;
      await addVisitHistoryApi({
        coll: "VisitHistory",
        payload: {
          candidateId: row.uiid,
          addedBy: user?.data?.uiid,
        },
      });
    } catch (error) {
      console.error("Error logging visit history:", error);
    }
  };

  const handleFetchNotes = async (applicant) => {
    setNotes([]);
    try {
      setNotesLoading(true);
      const res = await fetchAllNotes({
        coll: "Note",
        // pg: 1,
        // lim: 50,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: applicant.notes } },
        extret: "uiid firstName",
      });

      if (res?.data?.data) {
        const notes = res?.data?.data;
        const applicantId = applicant?.uiid;
        dispatch(updateApplicantsNotesArray({ applicantId, notes }))
      } else {
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setNotesLoading(false);
    }
  };

  const getHoveredNotes = async (applicant) => {
    setHoveredNotes([]);

    try {
      setNotesLoading(true);
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: applicant.notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 }
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setNotesLoading(false);
    }
  };

  const getHoveredClipboardLogs = async (applicantId) => {
    setHoveredClipboardLogs([]);

    try {
      const res = await fetchClipboardLogsApi({
        coll: "ClipBoardLog",
        fil: { 
          candidateId: { type: "NONE", value: applicantId },
        },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
        limit: 5 
      });

      if (res?.data) {
        setHoveredClipboardLogs(res.data.data || [] );
      } else {
        setHoveredClipboardLogs([]);
      }
    } catch (error) {
      console.error("Error fetching clipboard logs:", error);
    }
  };

  const getHoveredVisitHistorys = async (applicantId) => {
    setHoveredVisitHistorys([]);
    try {
      const res = await fetchVisitHistorysApi({
        coll: "VisitHistory",
        fil: { 
          candidateId: { type: "NONE", value: applicantId },
        },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
        limit: 5 
      });

      if (res?.data) {
        setHoveredVisitHistorys(res.data.data || []);
      } else {
        setHoveredVisitHistorys([]);
      }
    } catch (error) {
      console.error("Error fetching visit history:", error);
    }
  };

  const colApplicantDetails = [
    {
      key: "resume",
      label: "Resume/Applicants",
      render: (row) => (
        <div className="flex items-center ">
          <div>
            <DropdownMenu
              MenuSection={
                <div className="flex flex-col">
                  <Button
                    title={"Edit"}
                    icon={"edit_square"}
                    variant="text"
                    color="black"
                    size="xs-sm"
                    className="!justify-start py-2"
                    onClick={() => {
                      setSelectedApplicantId(row.uiid);
                      setIsEditMode(true);
                      setIsAddManualModalOpen(true);
                    }}
                  />

                  <Button
                    title={"Submit Job"}
                    icon={"check_circle"}
                    variant="text"
                    color="black"
                    size="xs-sm"
                    className="!justify-start py-2"
                    onClick={() => {
                      setSubmitModal(true);
                      setSelectedApplicant(row);
                    }}
                  />

                  <Button
                    title={"Compose Mail"}
                    icon={"mail"}
                    variant="text"
                    color="black"
                    size="xs-sm"
                    className="!justify-start py-2"
                    onClick={() => setComposeModal(true)}
                  />
                  <Button
                    title={"Profile Update Request"}
                    icon={"account_circle"}
                    variant="text"
                    color="black"
                    size="xs-sm"
                    className="!justify-start py-2"
                  />
                </div>
              }
            >
              <Button
                icon={"more_vert"}
                variant="text"
                type="icon"
                size="sm"
                color="black"
              />
            </DropdownMenu>
          </div>
          {/* <Button
            type="icon"
            color="warning"
            icon={"mark_unread_chat_alt"}
            variant="text"
            size="sm"
            onClick={() => setShowSingleNotes(true)}
          /> */}
          {row.notes && row.notes.length > 0 && (
            <div onMouseEnter={() => row?.notes?.length > 0 ? getHoveredNotes(row) : {}} onMouseLeave={() => setHoveredNotes([])}>
              <DualIcon
                size="sm"
                icon="chat"
                badgeIconColor={
                  row.notes?.length > 0 ? "bg-success-400" : "bg-dark"
                }
                onClick={() => {
                  setSelectedApplicant(row);
                  setShowSingleNotes(true);
                  if (row.notes && row.notes.length > 0) {
                    handleFetchNotes(row);
                    setShowDataId([row.id]);
                  } else {
                    setNotes([]);
                  }
                }}
                showTooltip={true}
                tooltipPosition="right"
                // tooltipDescription={
                //   row.notes?.length > 0 ? (
                //     <div className="flex flex-col gap-2">
                //       <p>{row.notes?.length} Notesfnkjdfbhdfvsdhvdsjhflv</p>
                //       <p>{row.notes?.length} Notes</p>
                //       <p>{row.notes?.length} Notes</p>
                //     </div>
                //   ) : (
                //     "Add note"
                //   )
                // }
                tooltipDescription={        
                  Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {hoveredNotes.map((hoveredNote, i) => (
                        <p key={i}>"{hoveredNote?.note || ""}" by {formatWords2(hoveredNote?.addedBy?.firstName) || ""} on {dateFormator(convertFromUTC(hoveredNote?.addedOn), "datetime-ampm") || ""}</p>
                      ))}
                    </div>
                  ) : (
                    "Add note"
                  )
                }
                tooltipDelay={500}
              />
            </div>
          )}
          {/* {row.notes && row.notes.length > 0 && (
            <Button
              type="icon"
              color="warning"
              icon={"mark_unread_chat_alt"}
              variant="text"
              size="sm"
              onClick={() => {
                setSelectedApplicantId(row._id); // track which applicant
                setShowSingleNotes(true);
              }}
            />
          )} */}

          <div
            onMouseEnter={() => getHoveredVisitHistorys(row.uiid)}
            onMouseLeave={() => setHoveredVisitHistorys([])}
          >
            <SmartTooltip
              description={
                Array.isArray(hoveredVisitHistorys) && hoveredVisitHistorys?.length > 0 ? (
                  <div className="flex flex-col gap-2">
                    {hoveredVisitHistorys.map((hoveredVisitHistory, i) => (
                      <p key={i}>last visited by {formatWords2(hoveredVisitHistory?.addedBy?.firstName) || ""} on {dateFormator(convertFromUTC(hoveredVisitHistory?.addedOn), "datetime-ampm") || ""}</p>
                    ))}
                  </div>
                ) : (
                  "View Details"
                )
              }
              noicon
            >
              <Button
                // type="icon"
                // color="black"
                // icon={"visibility"}
                // onClick={() => {
                //   setDetailsDrawer(true);
                // }}
                // variant="text"
                // size="sm"

                type="icon"
                color="black"
                icon={"visibility"}
                onClick={() => {
                  handleVisitHistory(row);
                  // setSelectedApplicant(row); // ← set the applicant first
                  setSelectedApplicantId(row.uiid);
                  setDetailsDrawer(true); // then open drawer
                }}
                variant="text"
                size="sm"
              />
            </SmartTooltip>
          </div>

          <div>{row.resume}</div>
        </div>
      ),
    },
    {
      key: "applicantName",
      label: "Applicant Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row.applicantName)}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <Link
            to={`/ats/applicants/applicant-details`}
            state={{ applicantId: row.uiid }}
            className="text-info-400 flex items-center gap-.5"
          >
            <span className="mx-2 line-clamp-1">
              {formatWords2(row.applicantName)}
            </span>
          </Link>
        </SmartTooltip>
      ),
    },
    {
      key: "email",
      label: "Email Address",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <div className="flex items-center line-clamp-1">
            <CopyToClipboard
              title={
                row?.email || row?.email?.primary?.email || row?.email?.primary
              }
              content={
                row?.email || row?.email?.primary?.email || row?.email?.primary
              }
            />
          {row?.email || row?.email?.primary?.email || row?.email?.primary}
        </div>
      ),
    },
    {
      key: "mobile",
      label: "Mobile Number",

      render: (row) => (
        <div className="flex items-center">
          {row.mobile !== "-" && (
            <div
              onMouseEnter={() => getHoveredClipboardLogs(row.uiid)}
              onMouseLeave={() => setHoveredClipboardLogs([])}
            >
              <CopyToClipboard
                description={
                  Array.isArray(hoveredClipboardLogs) && hoveredClipboardLogs?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {hoveredClipboardLogs.map((hoveredClipboardLog, i) => (
                        <p key={i}>last copied by {formatWords2(hoveredClipboardLog?.addedBy?.firstName) || ""} on {dateFormator(convertFromUTC(hoveredClipboardLog?.addedOn), "datetime-ampm") || ""}</p>
                      ))}
                    </div>
                  ) : (
                    "Copy"
                  )
                }
                title={
                  row.mobile
                }
                content={
                  row.mobile
                }
                onCopy={() => handleClipboardLog(row, "number")}
              />
            </div>
          )}
          {row.mobile !== "-" && (
            <SmartTooltip description={"Phone"} noicon>
              <Button
                type="icon"
                variant="text"
                color="black"
                size="sm"
                icon={"phone_in_talk"}
              />
            </SmartTooltip>
          )}
          {row.mobile}
          {row.mobile !== "-" && (
            <SmartTooltip description={"text"} noicon>
              <Button
                type="icon"
                variant="text"
                color="black"
                icon={"chat"}
                size="sm"
              />
            </SmartTooltip>
          )}
          {row.mobile !== "-" && (
            <SmartTooltip description={"Whatsapp"} noicon>
              <Button
                type="icon"
                variant="text"
                color="black"
                icon={whatsappIcon}
              />
            </SmartTooltip>
          )}
        </div>
      ),
    },
    {
      key: "source",
      label: "Source",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "city",
      label: "City",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row.city}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.city}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "state",
      label: "State",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row.state}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.state}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "status",
      label: "Applicant Status",
      width: "min-w-[200px]! max-w-[220px]!",
      render: (row) => {
        const currentOption = applicantStatusOptions.find(
          (opt) => opt.value === row.currentStatusValue
        );
        return (
          <div className="w-[180px] min-w-[160px]">
            <FormFieldSet
              type="select"
              noTitle
              size="sm"
              options={applicantStatusOptions}
              value={currentOption}
              onChange={(option) => handleStatusChange(option, row)}
            />
          </div>
        );
      },
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "workAuth",
      label: "Work Authorization",
    },
    {
      key: "addedBy",
      label: "Created By",
      render: (row) => (
        <div>
          <span className="">{formatWords2(row.addedBy)}</span>
        </div>
      ),
    },
    {
      key: "addedOn",
      label: "Created On",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.addedOn}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.addedOn}</div>
        </SmartTooltip>
      ),
    },
  ];

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} ${formattedTime}`;
  };

  const applicantsData = applicants;

  const mappedApplicantDetails = useMemo(() => {
    return mapTableRows(
      applicantsData?.data?.map((item, i) => ({
        id: item?._id || i,
        uiid: item?.uiid,
        resume: item?.uiid || "-",
        applicantName: `${formatWords2(item?.firstName || "")} ${formatWords2(item?.lastName || "")}`,
        email: item?.email?.primary?.email || "-",
        mobile: item?.mobile?.primary?.number
          ? `${item?.mobile?.primary?.code}${formatPhoneNumberLength(item?.mobile?.primary?.code, item?.mobile?.primary?.number)}`
          : "-",
        source: sourceOptions[item?.source] || "-",
        city: formatWords2(item?.location?.city || "-"),
        // state: item?.location?.state?.name || "-",
        state: formatWords2(item?.location?.state || "-"),
        // status: item?.status || "-",
        currentStatusValue: item?.currentStatus || 1,
        status: applicantStatus[item?.currentStatus || 1],
        jobTitle: formatWords2(item?.jobTitle || "-"),
        // workAuth: item?.workAuth || "--",
        workAuth: formatWords2(item?.workAuth?.trim() ? item.workAuth : "-"),
        addedBy: Array.isArray(item?.addedBy)
          ? formatWords2(item.addedBy?.[0]?.firstName ?? "-")
          : formatWords2(item?.addedBy?.firstName ?? "-"),
        addedOn: formatDateTime(item?.addedOn),
        notes: item?.notes || [],
        gender: item?.gender,
      })) || [],
      colApplicantDetails
    );
  }, [applicantsData, colApplicantDetails]);

  const [selectedRows, setSelectedRows] = useState([]);

  const handleModelClose = () => {
    setIsAddManualModalOpen(false);
  };
  const timeCalc = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return `${seconds}s ago`;
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    if (weeks < 5) return `${weeks}w ago`;
    if (months < 12) return `${months}mo ago`;
    return `${years}y ago`;
  };

  const handleAddNote = async () => {
    if (!note.trim()) {
      showToast("Please enter note!", "error");
      return;
    }

    try {
      setLoading(true);

      if (!selectedApplicant?.uiid) {
        showToast("Applicant UIID not found", "error");
        return;
      }
      const hadNoNotes =
        !selectedApplicant?.notes || selectedApplicant.notes.length === 0;

      const res = await addNoteApi({
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid,
          candidateId: selectedApplicant.uiid,
          note: note.trim(),
          source: 2, // applicant source
          priority: 3, // low priority default
        },
      });

      const newNoteUiid = res?.data?.data?.uiid;
      const newNote = res?.data?.data?.note;
      const newNoteAddedOn = res?.data?.data?.addedOn;
      const newNoteAddedBy = res?.data?.data?.addedBy;

      if (newNoteUiid) {
        trackEvent({
          eventName: "Note_Created",
          props: {
            candidateName: selectedApplicant?.applicantName
          }
        })
        dispatch(
          updateApplicantNotes({
            applicantId: selectedApplicant.uiid,
            newNoteUiid,
            uiid: newNoteUiid,
            note: newNote,
            addedBy: newNoteAddedBy,
            addedOn: newNoteAddedOn
          })
        );
        dispatch(
          updateApplicantWithNotes({
            applicantId: selectedApplicant.uiid,
            newNoteUiid,
            uiid: newNoteUiid,
            note: newNote,
            addedBy: newNoteAddedBy,
            addedOn: newNoteAddedOn
          })
        );
        const updatedApplicant = {
          ...selectedApplicant,
          notes: [...(selectedApplicant.notes || []), newNoteUiid],
        };
        if (!hadNoNotes) {
          await handleFetchNotes(updatedApplicant);
        } // else {
        //   dispatch(
        //     fetchAllApplicantsStart({
        //       coll: "Candidate",
        //       lim: limit,
        //       pg: page,
        //       ref: "Resume Submission",
        //       extret: "uiid firstName",
        //       sort: JSON.stringify({ uiid: -1 }),
        //     })
        //   );
        // }
        //setShowSingleNotes(false);
        setNote("");
        showToast("Note added successfully", "success", 2000);
        const data = res?.data?.data || {}
        dispatch(updateAllSourceNotes({
          applicantId: data.candidateId, newNoteUiid: data.uiid, uiid: data?.uiid,
          note: data?.note,
          addedBy: data?.addedBy,
          addedOn: data?.addedOn
        }))
        // Update search results if in search mode
        // if (searchValue.trim().length > 1 && searchApplicants?.data) {
        //   setSearchApplicants(prev => {
        //     const updatedData = prev.data.map(applicant => {
        //       if (applicant.uiid === selectedApplicant.uiid) {
        //         return {
        //           ...applicant,
        //           notes: [...(applicant.notes || []), newNoteUiid]
        //         };
        //       }
        //       return applicant;
        //     });

        //     return { ...prev, data: updatedData };
        //   });
        // }
        await handleFetchNotes(updatedApplicant);
      } else {
        showToast("Error adding note!", "error");
      }
    } catch (error) {
      console.error("Error adding note:", error);
      showToast("Failed to add note", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   setTotalCount(value?.allApplicants?.data || 0);
  // }, [value?.allApplicants?.data]);


  useEffect(() => {
    if (totalCount == 0) {
      dispatch(clearApplicants())
    }

  }, [dispatch, totalCount]);

  const handleSelectionChange = (row) => {
    setSelectedRows(row);
  };

  const OPERATOR_MAP = {
    equal: "EQUAL",
    notEqual: "EXCLUDE",
    contains: "CONTAINS",
    notContains: "NOT_CONTAINS",
    startsWith: "STARTS_WITH",
    endsWith: "ENDS_WITH",
    greaterThan: "GT",
    lessThan: "LT",
    greaterThanOrEqual: "GTE",
    lessThanOrEqual: "LTE",
  };

  const COLUMN_MAP = {
    applicantName: "applicantName",
    email: "email.primary.email",
    mobile: "mobile.primary.number",
    source: "source",
    city: "location.city",
    state: "location.state",
    status: "status",
    jobTitle: "jobTitle",
    workAuth: "workAuth",
    recruiter: "notifyTo.firstName",
    addedBy: "addedBy",
    addedOn: "addedOn",
  };

  const splitPhoneNumber = (phone) => {
    const phoneObj = parsePhoneNumberFromString(phone);

    if (!phoneObj) return null;

    return {
      countryCode: phoneObj.countryCallingCode,
      nationalNumber: phoneObj.nationalNumber,
    };
  };

  const convertConditions = (conditions = []) => {
    return conditions.map((cond) => {
      const apiField = COLUMN_MAP[cond.filterColunm] || cond.filterColunm;

      if (cond.filterColunm === "mobile") {
        const splitNumber = splitPhoneNumber(cond.filterValue);
        return {
          [COLUMN_MAP[cond.filterColunm]]: {
            type: OPERATOR_MAP[cond.operator],
            value: Number(splitNumber?.nationalNumber) || "",
          },
        };
      }

      return {
        [apiField]: {
          type: OPERATOR_MAP[cond.operator],
          value: cond.filterValue?.trim(),
        },
      };
    });
  };

  const buildFilParams = (config) => {
    const allFilters = convertConditions(config.allFilterConditions); // array
    const anyFilters = convertConditions(config.anyFilterConditions); // array

    let mergedFilters = [];
    mergedFilters.push(allFilters);
    mergedFilters.push(anyFilters);

    if (mergedFilters.length === 0) {
      return {};
    }

    return {
      uiid: {
        type: "TABLE_FILTER",
        value: mergedFilters,
      },
    };
  };

  // const handleFilterChange = React.useCallback((filterConfig) => {
  //   setActiveFilters(filterConfig); // <-- Only update state
  // }, []);

  const lastFilterRef = React.useRef(null);

  const handleFilterChange = React.useCallback((filterConfig) => {
    const newFilter = JSON.stringify(filterConfig);
    const oldFilter = lastFilterRef.current;

    if (newFilter === oldFilter) {
      return;
    }
    lastFilterRef.current = newFilter;
    setActiveFilters(filterConfig);
  }, []);

  const getFilterData = async (fil) => {
    const params = {
      coll: "Candidate",
      lim: limit,
      pg: page,
      useAggregate: true,
      // ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
      fil: JSON.stringify(fil),
    };

    try {
      setLoading(true);
      const response = await fetchNoteApi(params);

      if (response?.data) {
        setLoading(false);
        setFilteredApplicants({ data: response?.data?.data[0]?.rows, total: response?.data?.data[0]?.totalCount[0]?.count });
        // setTotalCount(response?.data?.data[0]?.totalCount[0]?.count);
      } else {
        setLoading(false);
        setFilteredApplicants([]);
      }
    } catch (error) {
      setLoading(false);
      console.error("API Error:", error);
      setFilteredApplicants([]);
    }
  };

  useEffect(() => {
    if (!activeFilters) return;

    if (
      activeFilters?.allFilterConditions?.length > 0 ||
      activeFilters?.anyFilterConditions?.length > 0
    ) {
      const fil = buildFilParams(activeFilters);
      getFilterData(fil);
    } else {
      setFilteredApplicants();
      // setTotalCount(value?.allApplicants?.data || 0);
    }
  }, [activeFilters]);

  const fetchAllApplicants = () => {
    dispatch(
      totalCountStart({
        collection: "candidates",
        coll: "Candidate",
        tname: "allApplicants",
        filters: { "currentStatus": { type: "EXCLUDE", value: 3 } },
        app: "ats",
      })
    );
    dispatch(
      fetchAllApplicantsStart({
        coll: "Candidate",
        lim: limit,
        pg: page,
        // ref: "Resume Submission Note",
        ref: "Resume Submission",
        extret: "uiid firstName",
        sort: JSON.stringify({ uiid: -1 }),
         fil: JSON.stringify({ "currentStatus": { type: "EXCLUDE", value: 3 } }),
        // onSuccess: (res) => {
        //   console.log("API Response Data:", res);
        // },
      })
    );
  };

  const handleStatusChange = async (statusValue, row) => {
    if (statusValue === 3) {
      setSelectedStatusOption(statusValue);
      setSelectedRowForStatus(row);
      setIsBlockedModalOpen(true);
      return;
    }
    try {
      const res = await updateApplicantStatusApi({
        coll: "Candidate",
        uiid: row.uiid,
        payload: [
          {
            type: "PUSH",
            value: {
              statusHistory: {
                addedBy: user?.data?.uiid,
                addedOn: new Date().toISOString(),
                status: statusValue,
              },
            },
          },
        ],
      });
      if (res?.data) {
        showToast("Status updated successfully", "success");
        dispatch(
          fetchAllApplicantsStart({
            coll: "Candidate",
            lim: limit,
            pg: page,
            ref: "Resume Submission",
            extret: "uiid firstName",
            sort: JSON.stringify({ uiid: -1 }),
             fil: JSON.stringify({ "currentStatus": { type: "EXCLUDE", value: 3 } }),
          })
        );
      }
    } catch (err) {
      showToast("Failed to update status", "error");
    } finally {
      setLoading(false);
      setSearchValue("")
    }
  };

  const handleBlockedSubmit = async () => {
    if (!blockedComment.trim()) {
      showToast("Please enter a comment!", "error");
      return;
    }
    try {
      setLoading(true);
      const res = await updateApplicantStatusApi({
        coll: "Candidate",
        uiid: selectedRowForStatus.uiid,
        payload: [
          {
            type: "PUSH",
            value: {
              statusHistory: {
                addedBy: user?.data?.uiid,
                addedOn: new Date().toISOString(),
                status: selectedStatusOption,
                note: blockedComment.trim(),
              },
            },
          },
        ],
      });

      if (res?.data) {
        await addNoteApi({
          coll: "Note",
          postActions: ["updateSource"],
          payload: {
            addedBy: user?.data?.uiid,
            candidateId: selectedRowForStatus.uiid,
            note: blockedComment.trim(),
            source: 2, // applicant source
            priority: 3, // low priority default
          },
        });

        showToast("Status updated to Blocked and note added", "success");
        setIsBlockedModalOpen(false);
        setBlockedComment("");
        dispatch(
          fetchAllApplicantsStart({
            coll: "Candidate",
            lim: limit,
            pg: page,
            ref: "Resume Submission",
            extret: "uiid firstName",
            sort: JSON.stringify({ uiid: -1 }),
             fil: JSON.stringify({ "currentStatus": { type: "EXCLUDE", value: 3 } }),
          })
        );
      }
    } catch (err) {
      showToast("Failed to update status", "error");
    } finally {
      setLoading(false);
      setSearchValue("")
    }
  };

  const fetchApplicantSearch = async (data) => {
    if (
      data.name.length > 1 ||
      data.mobile.length > 1 ||
      data.email.length > 1
    ) {
      let params = {
        coll: "Candidate",
        lim: limit,
        pg: page,
        ref: "Resume Submission",
        extret: "uiid firstName",
        sort: JSON.stringify({ uiid: -1 }),
      };
      if (data.searchType === "name") {
        params.fil = JSON.stringify({
          name: { type: "MUTLI_FEILD_SEARCH", value: data.name.toLowerCase() },
           "currentStatus": { type: "EXCLUDE", value: 3 }
          // lastName: { type: "SEARCH", value: data.name.toLowerCase() },
        });
      } else if (data.searchType === "email") {
        params.fil = JSON.stringify({ "email.primary.email": { type: "NONE", value: data.email.toLowerCase() }, "currentStatus": { type: "EXCLUDE", value: 3 } })

      } else if (data.searchType === "mobile") {
        params.fil = JSON.stringify({ "mobile.primary.number": { type: "NONE", value: data.mobile }, "currentStatus": { type: "EXCLUDE", value: 3 } })

      }

      try {
        // setLoading(true);
        // const searchData = await fetchAllApplicantsApi(params);
        dispatch(
          fetchAllApplicantsStart(params)
        );
        dispatch(
          totalCountStart({
            collection: "candidates",
            coll: "Candidate",
            tname: "allApplicants",
            app: "ats",
            filters: JSON.parse(params.fil),
          })
        );

        // if (searchData.success) {
        //   // setSearchApplicants(searchData.data);
        //   // setTotalCount(value?.allApplicantsSearch?.data);
        // } else {
        //   setSearchApplicants([]);
        //   // setTotalCount(value?.allApplicants?.data);
        // }
        // setLoading(false);
      } catch (error) {
        showToast("Failed to search Applicants", "error", 2000);
        // setLoading(false);
        setSearchApplicants([]);
        // setTotalCount(value?.allApplicants?.data);
      }
    } else {
      setSearchApplicants([]);
      // setTotalCount(value?.allApplicants?.data);
    }
  };

  useEffect(() => {
    if (searchValue.trim().length > 1) {
      setPage(1);
      handleSearch(searchValue);
    } else if (
      activeFilters?.allFilterConditions?.length > 0 ||
      activeFilters?.anyFilterConditions?.length > 0
    ) {
      const fil = buildFilParams(activeFilters);
      getFilterData(fil);
    } else {
      fetchAllApplicants();
      // setTotalCount(value?.allApplicants?.data || 0);
    }
  }, [dispatch, page, limit, searchValue]);


  // useEffect(() => {
  //   if (searchValue.trim().length > 1) {
  //     handleSearch(searchValue);
  //     setPage(1);
  //   } else {
  //     fetchAllApplicants();
  //     // setTotalCount(value?.allApplicants?.data || 0);
  //   }

  // }, [searchValue]);

  const fetchIntegrationAccess = async () => {
    // setLoader(true);
    try {
      const params = {
        coll: "IntegrationAccess",
        fil: {
          userId: {
            type: "FIND_INTIGRATION_ACCESS",
            value: user?.data?.uiid,
            category: 6,
            categoryType: 1,
            status: 1
          },
        },
        useAggregate: true,
      };

      // const response = await getAllIntegrationAccess(params);
      // console.log("response",response)

      const dispatchData = () => {
        dispatch(setAllApplicantAccessidStart(params));
        const { accessData } = useSelector((state) => state.internalDbES);
        return {
          status:
            accessData?.allapplicant?.[0]?.integrationData?.status ?? null,
          accessId: accessData?.allapplicant?.[0]?.uiid ?? null,
        };
      };

      const status =
        accessData?.allapplicant?.[0]?.integrationData?.status ??
        dispatchData()?.status;
      const uiid =
        accessData?.allapplicant?.[0]?.uiid ?? dispatchData()?.accessId;

      // if (typeof status !== "undefined") {
      if (status === 1) {
        setAccessId(uiid);
      }
    } catch (err) {
      console.error("Error fetching integration access:", err);
    } finally {
      // setLoader(false);
    }
  };
  useEffect(() => {
    fetchIntegrationAccess();
  }, []);
  useEffect(() => {
  }, [selectedApplicantwithNotes]);

  const searchTimer = useRef(null);

  const handleSearch = (value) => {
    let searchType = "";
    let email = "";
    let name = "";
    let mobile = "";
    let countryCode = "";

    const trimmed = (value || "").trim();

    if (trimmed.includes("@")) {
      searchType = "email";
      email = trimmed;
    } else {
      const cleaned = trimmed.replace(/[\s\-().]/g, "");
      const numericRegex = /^\+?\d+$/;
      if (!numericRegex.test(cleaned)) {
        searchType = "name";
        name = trimmed;
      }
      else {
        const validCC = ["91", "1"];
        if (cleaned.startsWith("+")) {
          const digits = cleaned.slice(1);
          let matched = false;
          for (const cc of validCC) {
            if (digits.startsWith(cc)) {
              matched = true;
              countryCode = "+" + cc;
              mobile = digits.slice(cc.length);
              break;
            }
          }
          if (!matched) {
            mobile = digits;
          }
          searchType = "mobile";
        } else {
          let matched = false;
          for (const cc of validCC) {
            if (cleaned.startsWith(cc)) {
              matched = true;
              countryCode = "+" + cc;
              mobile = cleaned.slice(cc.length);
              break;
            }
          }
          if (!matched) {
            mobile = cleaned;
          }
          searchType = "mobile";
        }
      }
    }

    if (searchTimer.current) clearTimeout(searchTimer.current);

    searchTimer.current = setTimeout(() => {
      fetchApplicantSearch({
        searchType,
        email,
        name,
        mobile,
        countryCode,
      });
    }, 500);
  };

  // if (loading) {
  //   return (
  //     <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
  //       <LogoLoader />
  //     </div>
  //   );
  // }

  return (
    <div className="flex flex-col mt-5 overflow-auto">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showCheckbox
          columns={colApplicantDetails}
          rows={mappedApplicantDetails}
          onSelectionChange={handleSelectionChange}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          defaultSelectedRows={selectedRows}
          tdClassName="!py-3"
          tableId={"applicants"}
          serverFiltering={true}
          onFilterChange={handleFilterChange}
          serverSearchValue={searchValue}
          serverOnSearch={(key, value) => {
            setSearchValue(value)
            if (!value) {
              fetchAllApplicants()
            }
          }}
          toolbarRight={{
            filter: true,
            search: true,
            add: [
              {
                component: (
                  <div className="flex items-center gap-2">
                    {/* <Button title="Job Board" size="sm" /> */}
                    <Button
                      title="Add new"
                      size="sm"
                      icon="add"
                      color="info"
                      onClick={() => setIsModalOpen(true)}
                    />
                    {/* <Button
                        type="icon"
                        variant="text"
                        color="info"
                        size="sm"
                        icon="filter_alt"
                        className="bg-info-50 !rounded"
                      /> */}
                    {/* <Button
                      type="icon"
                      variant="text"
                      size="sm"
                      color="info"
                      icon="cached"
                      className="bg-info-50 !rounded"
                    /> */}
                  </div>
                ),
              },
            ],
          }}
        />

        {showSingleNotes && (
          <div className="w-md shadow p-2 overflow-auto flex flex-col gap-5">
            <div className="p-2">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-semibold">Add Notes</h5>
                <Button
                  type="icon"
                  icon={"close"}
                  onClick={() => {
                    setShowSingleNotes(false);
                    setSelectedRows((prev) =>
                      prev.filter((id) => !showDataId.includes(id))
                    );
                    setShowDataId([]);
                  }}
                  size="xs"
                />
              </div>
              <FormFieldSet
                type="textArea"
                rows={5}
                placeholder=""
                value={note}
                onChange={(value) => setNote(value)}
              />
            </div>
            {/* <div className="p-2">
              <h6 className="font-semibold mb-2">Added Notes</h6>
              <div className="my-3">
                <DetailCard
                  size="xs"
                  title={
                    <div className="flex items-center gap-4 p-2">
                      <Avatar alt={"Ershad Mohammad"} showInitials noBorder />
                      <InfoTextAdv
                        title={"Ershad Mohammad"}
                        titleProps={{
                          className: "!text-black !text-sm  font-[600]",
                        }}
                        value={
                          <p className="line-clamp-1 text-gray font-[600] text-xs">
                            9 hours ago
                          </p>
                        }
                      />
                    </div>
                  }
                  headeRight={
                    <div>
                      <Button
                        icon={"more_vert"}
                        variant="text"
                        type="icon"
                        color="black"
                      />
                    </div>
                  }
                >
                  <p className="text-sm p-3 ">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  </p>
                </DetailCard>
              </div>
              <div className="my-3">
                <DetailCard
                  size="xs"
                  title={
                    <div className="flex items-center gap-4 p-2">
                      <Avatar alt={"Ramesh Manthri"} showInitials noBorder />
                      <InfoTextAdv
                        title={"Ramesh Manthri"}
                        titleProps={{
                          className: "!text-black !text-sm  font-[600]",
                        }}
                        value={
                          <p className="line-clamp-1 text-gray font-[600] text-xs">
                            6 hours ago
                          </p>
                        }
                      />
                    </div>
                  }
                  headeRight={
                    <div>
                      <Button
                        icon={"more_vert"}
                        variant="text"
                        type="icon"
                        color="black"
                      />
                    </div>
                  }
                >
                  <p className="text-sm p-3 ">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  </p>
                </DetailCard>
              </div>
            </div> */}
            <div className="p-2">
              <h6 className="font-semibold mb-2">Added Notes</h6>

              {/* {rowData[0]?.notes?.length > 0 ? (
                rowData[0].notes.map((note) => ( */}
              {notesLoading ? (
                <Skeleton variant="paragraph" lines={4} />
              ) : selectedApplicantwithNotes?.length > 0 ? (
                selectedApplicantwithNotes?.map((note) => (
                  <div className="my-3" key={note._id || note?.uiid}>
                    <DetailCard
                      size="xs"
                      title={
                        <div className="flex items-center gap-4 p-2">
                          <Avatar
                            alt={`${formatWords2(note.addedBy?.firstName)}`}
                            showInitials
                            noBorder
                          />
                          <InfoTextAdv
                            title={`${formatWords2(note.addedBy?.firstName)}`}
                            titleProps={{
                              className: "!text-black !text-sm font-[600]",
                            }}
                            value={
                              <p className="line-clamp-1 text-gray font-[600] text-xs">
                                {formatDateTime(convertFromUTC(note?.addedOn))}
                              </p>
                            }
                          />
                        </div>
                      }
                      headeRight={
                        <div>
                          <Button
                            icon={"more_vert"}
                            variant="text"
                            type="icon"
                            color="black"
                          />
                        </div>
                      }
                    >
                      <p className="text-sm p-3">{note?.note}</p>
                    </DetailCard>
                  </div>
                ))
              ) : (
                <p className="text-gray-600 font-md text-md">No Notes Found</p>
              )}
            </div>
            <div className="mt-auto pt-4 flex justify-center">
              <Button title="Apply" onClick={handleAddNote} />
            </div>
          </div>
        )}
      </div>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        applicantId={selectedApplicantId}
        source={"AllApplicants"}
        page={page}
        limit={limit}
      />
      <AddApplicantModal
        isOpen={isAddManualModalOpen}
        onClose={() => {
          handleModelClose();
          setIsEditMode(false);
          setSelectedApplicantId(null);
        }}
        edit={isEditMode}
        applicantId={selectedApplicantId}
        parsedData={parsedResumeData}
        preselectedResume={uploadedFile}
        onSuccess={() => {
          dispatch(
            fetchAllApplicantsStart({
              coll: "Candidate",
              lim: limit,
              pg: page,
              // ref: "Resume Submission Note",
              ref: "Resume Submission",
              extret: "uiid firstName",
              sort: JSON.stringify({ uiid: -1 }),
              fil: JSON.stringify({ "currentStatus": { type: "EXCLUDE", value: 3 } }),
              // onSuccess: (res) => {
              //   console.log("API Response Data:", res);
              // },
            })
          );
        }}
      />

      <Modal
        title={"Add Applicant"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="max-w-xl"
      >
        <div className="flex justify-center items-center gap-3 p-4">
          {/* <Button
                icon="quick_reference_all"
                color="black"
                title={"Parse Resume"}
              /> */}
          <div className="flex items-center col-span-2 my-4">
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              onChange={handleFileChange}
              disabled={isParsing || loading}
              // multiple
              accept=".pdf,.doc,.docx"
            />
            <Button
              onClick={handleAddFilesClick}
              color="black"
              icon={"quick_reference_all"}
              title={"Parse Resume"}
            />
          </div>

          <Button
            color="black"
            title={"Bulk Parse"}
            onClick={() => {
              if (!accessId && !accessData?.allapplicant?.[0]?.uiid) {
                showToast("AccessID not found!", "error");
                return;
              }
              setBulkModal(true);
            }}
          />
          <Button
            title={"Manual Creation"}
            onClick={() => {
              setIsAddManualModalOpen(true);
              setIsModalOpen(false);
            }}
          />
        </div>
        <Backdrop isOpen={loading}>
          <LogoLoader />
        </Backdrop>
      </Modal>

      <Modal
        isOpen={composeModal}
        onClose={() => setComposeModal(false)}
        width="max-w-4xl"
        title={"Compose"}
      >
        <div className="px-4 py-2">
          <div className="grid grid-cols-4 gap-6 ">
            <FormFieldSet
              type="select"
              placeholder="Select"
              title="Email Source"
              options={[
                { label: "Gmail", value: 1 },
                { label: "Outlook", value: 2 },
                { label: "Mailgun", value: 3 },
                { label: "AWS-SES", value: 4 },
              ]}
              // value={formData.emailSource}
              // onChange={(value) => handleChange("emailSource", value)}
              // error={errors.emailSource}
              shadow={true}
            />
            <FormFieldSet
              type="emailSourceAccounts"
              placeholder="Select Account"
              title="Email Account"
              // options={[
              //   { label: "brown@tektreeinc.com", value: "1" },
              //   { label: "aden@tektreeinc.com", value: "2" },
              // ]}
              // value={formData.emailAccount}
              // onChange={(value) => handleChange("emailAccount", value)}
              // error={errors.jobCode}
              // disabled={!formData.emailSource}
              // filters={{ category: 11, type: formData.emailSource }}
              // filters={{ employeeId: employeeProfileUiid }}
              shadow={true}
            />
            {/* <FormFieldSet
                    type="select"
                    placeholder="Select Email"
                    title="Type of Email"
                    options={[
                      { label: "Latest Data", value: 1 },
                      { label: "Follow-up Data", value: 2 },
                    ]}
                    // value={formData.typeOfEmail}
                    // onChange={(value) => {
                    //   handleChange("typeOfEmail", value);
                    //   const selectedDate =
                    //     value === 1 ? dayjs() : dayjs().subtract(1, "day");
                    //   handleChange("date", selectedDate);
                    //   fetchFollowAssignments(selectedDate);
                    // }}
                    // error={errors.typeOfEmail}
                    shadow={true}
                  />
                  <FormFieldSet
                    type="datepicker"
                    placeholder="Select Account"
                    title="Date Picker"
                    //value={formData.date}
                    // onChange={(value) => {
                    //   handleChange("date", value);
                    //   fetchFollowAssignments(value);
                    // }}
                    // error={errors.date}
                    shadow={true}
                  /> */}
            <FormFieldSet
              type="templates"
              placeholder="Select"
              title="Template"
              options={[
                { label: "Brown", value: "1" },
                { label: "Aden", value: "2" },
              ]}
              // value={formData.template}
              // onChange={(value) => {
              //   handleChange("template", value);
              //   handleGetTemplate(value?.value);
              // }}
              // error={errors.template}
              // disabled={!formData.emailAccount}
              // filters={{ userId: formData.emailAccount?.userId }}
              // filters={{ userId: 3 }}
              shadow={true}
            />
            <FormFieldSet
              placeholder="Subject"
              title="Subject"
              // value={formData.subject}
              // onChange={(value) => handleChange("subject", value)}
              // error={errors.subject}
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-1 my-4 gap-6">
            <FormFieldSet
              type="textArea"
              title="Text Here"
              // value={formData.emailText}
              // onChange={(value) => handleChange("emailText", value)}
              // error={errors.emailText}
              rows={4}
              shadow={true}
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button
              title={"Cancel"}
              variant="outlined"
              onClick={() => setComposeModal(false)}
            />
            <Button
              title={"Save"}
            // onClick={()=>handleSendEmails()}
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isBlockedModalOpen}
        onClose={() => {
          setIsBlockedModalOpen(false);
          setBlockedComment("");
        }}
        title="Reason For Blocking"
        width="max-w-md"
      >
        <div className="p-4">
          <FormFieldSet
            type="textArea"
            title="Comment"
            rows={4}
            value={blockedComment}
            onChange={(val) => setBlockedComment(val)}
            placeholder="Enter reason for blocking..."
          />
          <div className="flex justify-end gap-2 mt-4">
            <Button
              title="Cancel"
              variant="outlined"
              onClick={() => {
                setIsBlockedModalOpen(false);
                setBlockedComment("");
              }}
            />
            <Button
              title="Submit"
              onClick={handleBlockedSubmit}
            //loading={loading}
            />
          </div>
        </div>
      </Modal>

      <SubmitModal
        isOpen={submitModal}
        onClose={() => setSubmitModal(false)}
        applicant={selectedApplicant}
      />
      <BulkModal
        isOpen={bulkModal}
        onClose={() => setBulkModal(false)}
        accessId={accessId || accessData?.allapplicant?.[0]?.uiid}
      />
      <Backdrop isOpen={pageLoading || loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AllApplicants;
